import OppoShare from '@oppobrowser/browser_sdk/src/share'

export function shareConfig(data) {
  OppoShare.shareConfig({
    triggerOnMenu: true
  })

  const options = {
    title: data.title, // 分享标题
    desc: data.desc, // 分享描述
    link: data.link, // 分享链接
    imgUrl: data.imgUrl, // 分享图标
    dataUrl: '',
    type: '',
    success() {
      console.log('success')
    },
    cancel() {
      console.log('分享cancel')
    }
  };
  OppoShare.onMenuShareToQQ(options)
  OppoShare.onMenuShareToWeChatFriends(options)
  OppoShare.onMenuShareToWeChatMoment(options)
  OppoShare.onMenuShareToWeibo(options)
}

